import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import SwitchField from "components/SwitchField";
import { memo } from "react";

/* eslint-disable react/prop-types */

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    startDate,
    endDate,
    firstTime,
    supplementaryForThe,
    taxPayerId,
    taxPayerName,
    taxAgencyName,
    taxAgencyId,
    taxAgentContract,
    taxAgentContractDate,
    contractorContract,
    contractorContractDate
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
        <DatepickerField
            label={startDate.label}
            name={startDate.name}
            error={errors.startDate && touched.startDate}
            success={values.startDate?.toString().length > 0 && !errors.startDate}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
        <DatepickerField
            label={endDate.label}
            name={endDate.name}
            error={errors.endDate && touched.endDate}
            success={values.endDate?.toString().length > 0 && !errors.endDate}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxPayerName.name}
            label={taxPayerName.label}
            value={values.taxPayerName}
            error={errors.taxPayerName && touched.taxPayerName}
            success={
              values.taxPayerName?.toString().length > 0 && !errors.taxPayerName
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxPayerId.name}
            label={taxPayerId.label}
            value={values.taxPayerId}
            error={errors.taxPayerId && touched.taxPayerId}
            success={
              values.taxPayerId?.toString().length > 0 && !errors.taxPayerId
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentContract.name}
            label={taxAgentContract.label}
            value={values.numberContract}
            error={errors.taxAgentContract && touched.taxAgentContract}
            success={values.taxAgentContract?.toString().length > 0 && !errors.taxAgentContract}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
        <DatepickerField
            label={taxAgentContractDate.label}
            name={taxAgentContractDate.name}
            error={errors.taxAgentContractDate && touched.taxAgentContractDate}
            success={values.taxAgentContractDate?.toString().length > 0 && !errors.taxAgentContractDate}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={contractorContract.name}
            label={contractorContract.label}
            value={values.contractorContract}
            error={errors.contractorContract && touched.contractorContract}
            success={values.contractorContract?.toString().length > 0 && !errors.contractorContract}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
        <DatepickerField
            label={contractorContractDate.label}
            name={contractorContractDate.name}
            error={errors.contractorContractDate && touched.contractorContractDate}
            success={values.contractorContractDate?.toString().length > 0 && !errors.contractorContractDate}
          />
        </Grid>
       
      </Grid>
    </Box>
  );
}


Fields.displayName = "Fields";

export default memo(Fields);